import {
  employeeListShortService,
  departmentListShortService,
  titleListShortService,
  branchListShortService,
  applicationListShortService,
  organizationListShortService,
  roleListShortService,
  featureListShortService,
  tenantListShortService,
  workLevelListShortService,
  contractTypeListShortService,
  masterDataCountryListShortService,
  masterDataProvinceListShortService,
  masterDataDistrictListShortService,
  masterDataWardListShortService,
  masterDataTimezoneListShortService,
} from "services";
import { checkMainLan } from "utils";

import { ModelName } from "./types";

export const getServices = (
  model: ModelName,
  page: number,
  keyword?: string,
  depField?: number | string
) => {
  const paginationConfig = {
    page: page || 1,
    limit: 50,
    status: 1,
  };
  switch (model) {
    case "employee":
      return employeeListShortService({
        fullName: keyword,
        organizationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "department":
      return departmentListShortService({
        name: keyword,
        organizationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "title":
      return titleListShortService({
        name: keyword,
        organizationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "branch":
      return branchListShortService({
        name: keyword,
        organizationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "application":
      return applicationListShortService({
        name: keyword,
        ...paginationConfig,
      });

    case "organization":
      return organizationListShortService({
        name: keyword,
        tenantId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "role":
      return roleListShortService({
        name: keyword,
        applicationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "feature":
      return featureListShortService({
        name: keyword,
        applicationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "tenant":
      return tenantListShortService({
        name: keyword,
        ...paginationConfig,
      });

    case "workLevel":
      return workLevelListShortService({
        name: keyword,
        organizationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "contractType":
      return contractTypeListShortService({
        name: keyword,
        organizationId: Number(depField) || undefined,
        ...paginationConfig,
      });

    case "country":
      return masterDataCountryListShortService({
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
        ...paginationConfig,
      });

    case "province":
      return masterDataProvinceListShortService({
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
        ...paginationConfig,
        countryId: depField as number,
      });

    case "district":
      return masterDataDistrictListShortService({
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
        ...paginationConfig,
        provinceId: depField as number,
      });

    case "ward":
      return masterDataWardListShortService({
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
        ...paginationConfig,
        districtId: depField as number,
      });

    case "timezone":
      return masterDataTimezoneListShortService({
        name: keyword,
        ...paginationConfig,
      });

    default:
      return employeeListShortService({ fullName: keyword });
  }
};
